export default "__VITE_ASSET__BEdOqADY__"